import { globalRegex } from '@Src/utils/regex/regex.constant';
import { ValidFields } from '@Src/utils/messages/validFields.constant';
import * as Yup from 'yup';

export const ContactUsSchema = Yup.object({
  Name: Yup.string().required("Name is required").max(100,"Name must be within 100 characters").matches(globalRegex.ONLY_ALBHABET.REGEX, globalRegex.ONLY_ALBHABET.MESSAGE),
  EmailId: Yup.string().email("Invalid email").required("Email is required").max(100, "Email must be within 100 characters"),
  ContactNumber: Yup.string().min(ValidFields.MOBILE.MIN, ValidFields.MOBILE.SHORT_MESSAGE).max(ValidFields.MOBILE.MAX, ValidFields.MOBILE.LONG_MESSAGE).required(ValidFields.MOBILE.REQUIRED).matches(globalRegex.MOBILE_NUMBER.REGEX, globalRegex.MOBILE_NUMBER.MESSAGE),
  Subject: Yup.string().required("Subject is required").max(100, "Subject must be within 100 characters"),
  Description: Yup.string().required("Message is required").min(10, "Message should be at least 10 characters"),
  // Remarks: Yup.string().min(ValidFields.REMARKS.MIN, ValidFields.REMARKS.SHORT_MESSAGE).matches(globalRegex.BLANK_SPACE.REGEX, ValidFields.REMARKS.MATCH_MESSAGE),
})

export const ContactUsInitialValue = {
  Name: "",
  EmailId: "",
  ContactNumber: '',
  Subject: "",
  Description: "",
  //  Remarks : ""
}